export const LeasePdfViewSchema = {
    full_name_sign_Lease:[
        { rule: "required", message: "Name required" },
    ]
}